import axios from 'axios';

let token = '';
if (localStorage.getItem('user')) {
  token = JSON.parse(localStorage.getItem('user'))['api_token'];
}

export const getTriggersService = (courseId) => {
  return axios.get(`${process.env.REACT_APP_API_URL}/curso/${courseId}/triggers?api_token=${token}`);
};

export const createTriggerService = (data) => {
  return axios.post(`${process.env.REACT_APP_API_URL}/curso/trigger/create?api_token=${token}`, data);
};

export const updateTriggerService = (id, data) => {
  return axios.put(`${process.env.REACT_APP_API_URL}/curso/trigger/update/${id}?api_token=${token}`, data);
};

export const deleteTriggerService = (id) => {
  return axios.delete(`${process.env.REACT_APP_API_URL}/curso/trigger/delete/${id}?api_token=${token}`);
};

export const toggleTriggerService = (id) => {
  return axios.put(`${process.env.REACT_APP_API_URL}/curso/trigger/toggle/${id}?api_token=${token}`);
};

export const getCanvasAssignmentsService = (canvasId) => {
  return axios.get(`${process.env.REACT_APP_API_URL}/canvas/course/${canvasId}/assignments?api_token=${token}`);
};
